import type { z } from 'zod';

import i18n from '@/lib/i18n';
import { createPhoneNumberSchema } from '@/utils/phone-number';

const phoneNumberSchema = createPhoneNumberSchema({
  areaCode: () => i18n.t('institutionDetails.person.errors.areaCode'),
  mobilePhone: () => i18n.t('personalInformation.errors.mobilePhoneInvalid'),
});

/** fast-api checks the country code and the number together, as the number's length limit counts the code's digits */
export const phoneNumberRefinement = (data: { areaCode: string; phone: string }, ctx: z.RefinementCtx) => {
  // An empty part already has its required message
  if (!data.areaCode || !data.phone) return;

  const result = phoneNumberSchema.safeParse({ areaCode: data.areaCode, mobilePhone: data.phone });
  if (result.success) return;

  for (const { message, path } of result.error.issues) {
    ctx.addIssue({ code: 'custom', message, path: [path[0] === 'areaCode' ? 'areaCode' : 'phone'] });
  }
};
